<template>
    <div>
        <div class="px-4 pt-13 pb-0 background--paper divider--container">
            <div class="container mx-auto text-center">
                <h2>FAQs</h2>
                <div class="faqs w-full md:w-1/2 mx-auto">
                    <faq-item v-for="(item, index) in faqItems" :key="index" :item="item"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FaqItem from '@/components/partials/faq/FaqItem';

export default {
    name: 'FaqSubFooter',
    components: {
        FaqItem,
    },
    props: {
        faqItems: {
            required: true,
            type: Array,
        },
    },
};
</script>
